import React from 'react';
import { MoleculeInfo, StatData } from '../../MoleculeSearch.type';
import './MoleculeHeaderSection.styles.scss';
import { AtomIcon, ExternalLink } from 'lucide-react';

interface MoleculeHeaderSectionProps {
  moleculeInfo: MoleculeInfo;
  stats: StatData[];
}

const MoleculeHeaderSection: React.FC<MoleculeHeaderSectionProps> = ({ moleculeInfo, stats }) => {
  const handleCheckCrossOrigin = (item: string) => {
    const encodedItem = encodeURIComponent(item.trim());
    const url = `https://rulings.cbp.gov/search?term=${encodedItem}&collection=ALL&commodityGrouping=ALL&sortBy=RELEVANCE&pageSize=30&page=1`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="molecule-header">
      <div className="container">
        <div className="molecule-title">
          <div className="molecule-icon">
            {/* <i className="fas fa-atom"></i> */}
            <AtomIcon size={50} />
          </div>
          <div className="molecule-info">
            <h1>{moleculeInfo.name}</h1>
            <div className="molecule-meta">
              <div className="meta-item">
                <span>{moleculeInfo.therapeuticClass}</span>
                {moleculeInfo.name.split('/').map((item: string) => {
                  return (
                    <button
                      key={item}
                      type="button"
                      className="meta-item-button"
                      onClick={() => handleCheckCrossOrigin(item)}
                      title={`Open CROSS Origin search for ${item.trim()} in new tab`}
                    >
                      <span>Check Cross Origin of {item.trim()}</span>
                      <ExternalLink size={14} />
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Market Stats Summary */}
        <div className="stats-summary">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MoleculeHeaderSection;
